import React from "react";
import {
  Grid,
  StatusChip,
  BadgeColor,
  Button,
  Divider,
  List,
  Card,
  Text,
  Icons,
} from "@pushpress/shared-components";
import { IAppsFields } from "../../../../types/appstore";
import styles from "./Marketing.module.scss";

const Marketing = ({
  app,
  onJoinWaitlist,
}: {
  app: IAppsFields;
  onJoinWaitlist?: () => void;
}) => {
  if (!app) {
    return <></>;
  }

  return (
    <Grid container paddingX={3} paddingY={5}>
      {app.beta && onJoinWaitlist && (
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Card className={styles.betaBanner}>
                <Card.Content>
                  <Grid container spacing={2}>
                    <Grid item xs={1}>
                      <Grid container justifyContent="center" spacing={0}>
                        <Grid item>
                          <svg
                            width="15"
                            height="22"
                            viewBox="0 0 15 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 21C2.50538 21 4.21147 19.7957 4.15412 16.1254C4.13467 14.8805 4.12566 13.4299 4.12319 11.9677M4.12319 11.9677C4.11837 9.11947 4.13833 6.22761 4.15412 4.7276C4.20191 3.48507 5.02867 1 7.95341 1C10.8781 1 12.0394 3.22222 12.0394 4.7276C12.0394 6.06256 11.2509 8.53912 8.81362 8.59857C11.2509 8.53912 13.5448 9.53047 13.5448 13.2581C13.5448 16.1254 10.7133 17.4158 8.81362 17.4158C6.91398 17.4158 4.12319 16.1541 4.12319 11.9677Z"
                              stroke="#2A3540"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={11}>
                      <Grid container columnSpacing={2}>
                        <Grid item xs={12}>
                          <Text variant="body-lg">
                            {app.name} is currently in Beta. Join the waitlist
                            to get access.
                          </Text>
                        </Grid>
                        <Grid item xs={12}>
                          {app.betaRegistered ? (
                            <Button
                              buttonType="secondary"
                              text="You're on the waitlist"
                              size="medium"
                              disabled
                            />
                          ) : (
                            <Button
                              buttonType="secondary"
                              onClick={onJoinWaitlist}
                              text="Join waitlist"
                              size="medium"
                              icon={Icons.Plus}
                              iconLocation="left"
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card.Content>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12}>
        <Grid container>
          {app.types.map((type, index) => (
            <Grid item xs="auto" key={index}>
              <StatusChip label={type.name} color={BadgeColor.White} />
            </Grid>
          ))}
          {app.categories.map((category, index) => (
            <Grid item xs="auto" key={index}>
              <StatusChip label={category.name} color={BadgeColor.White} />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} marginY={1} className={styles.content}>
        <Grid container spacing={3} marginY={1}>
          <Grid item sm={6}>
            <h1 className={styles.header}>{app.name}</h1>
            <div className="tw-h-2" />
            <p>{app.description}</p>
            <div className="tw-h-4" />
            <Button
              buttonType="secondary"
              href={app.learnMoreLink}
              text="Learn More"
              size="medium"
              target="_blank"
            />
          </Grid>
          <Grid item sm={6} marginY={1}>
            <h4 className={styles.header}>Features</h4>
            <div className="tw-h-2" />
            <List>
              {app.features &&
                app.features.map((feature, index) => (
                  <List.Item key={index}>{feature}</List.Item>
                ))}
            </List>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} columnSpacing={2}>
        <Grid container>
          {app.developers.length > 0 && (
            <Grid item xs={12} sm={6} marginY={2}>
              <h4>Developer</h4>
              <div className="tw-h-2" />
              <Grid container direction="column">
                {app.developers.map((dev) => (
                  <Grid item xs={12} key={dev.fields.name}>
                    <h5 className={styles.developerTitle}>{dev.fields.name}</h5>
                    <a href={dev.fields.url} target="_blank" rel="noreferrer">
                      {dev.fields.url}
                    </a>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
          {app.resources.length > 0 && (
            <Grid item xs={12} sm={6} marginY={2}>
              <h4>Resources</h4>
              <div className="tw-h-2" />
              {app.resources.map((resource) => (
                <div key={resource.fields.name}>
                  <a
                    href={resource.fields.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {resource.fields.name}
                  </a>
                </div>
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Marketing;
